import React, { useState, useEffect, useCallback } from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import Button from "@src/components/core-button"
import { useFormContext } from "react-hook-form"
import { Label, Error } from "./input.styled"

const InputWrapper = styled.div`
  display: flex;
  align-items: center;
`
const NumberInputWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

const StyledValue = styled.span`
  display: inline-block;
  padding: 0 10px;
  min-width: 42px;
  text-align: center;
  font-weight: bold;
  @media only screen and (${props => props.theme.screen.small.min}) {
    min-width: 54px;
    font-size: 1.25em;
  }
`

const InputNumberButtons = ({
  className,
  id,
  name,
  label,
  min,
  max,
  validate,
  required,
}) => {
  const {
    register,
    setValue,
    getValues,
    formState: { errors },
  } = useFormContext()
  const [value, setInternalValue] = useState(getValues(name) || min || 0)

  const updateValue = useCallback(
    newValue => {
      if (newValue < min) {
        newValue = min
      } else if (newValue > max) {
        newValue = max
      }
      setInternalValue(newValue)
      setValue(name, newValue)
    },
    [setInternalValue, min, max, setValue, name],
  )

  useEffect(() => {
    register(name, { validate: validate })
    if (value !== getValues(name)) {
      setValue(name, value)
    }
  }, [register, setValue, name, value, getValues, validate])

  return (
    <NumberInputWrapper>
      <Label htmlFor={name} required={required}>
        {label}
      </Label>
      <InputWrapper className={className} id={id}>
        <Button
          size="small"
          variant="circle"
          icon="minus"
          onClick={() => {
            updateValue(value - 1)
          }}
        />
        <StyledValue>{value}</StyledValue>
        <Button
          size="small"
          variant="circle"
          icon="plus"
          onClick={() => {
            updateValue(value + 1)
          }}
        />
      </InputWrapper>
      {errors[name] && (
        <Error
          dangerouslySetInnerHTML={{ __html: errors[name].message }}
        ></Error>
      )}
    </NumberInputWrapper>
  )
}

InputNumberButtons.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string,
  name: PropTypes.string.isRequired, // name is now required
  min: PropTypes.number,
  max: PropTypes.number,
}

export default InputNumberButtons
